import { useState, useEffect } from "react";

const images = [
  {
    link: require("../Images/home1.png"),
    text: `Welcome to Plus Credit — your gateway to smarter money moves.
We’re redefining access to credit and investments with digital-first solutions that work for your lifestyle. Whether you're saving, spending, or leveling up, we make it easy, fast, and secure.`,
  },
  {
    link: require("../Images/home2.png"),
    text: `We don’t just offer financial products — we unlock possibilities.
From flexible savings and proof of funds to easy device financing and high-yield dollar investments, Plus Credit connects you to the tools that help you grow, travel, and thrive.`,
  },
];

const TwoImageCarousel = () => {
  const [current, setCurrent] = useState(0);

  const toggleSlide = () => {
    setCurrent((prev) => (prev === 0 ? 1 : 0));
  };

  useEffect(() => {
    const interval = setInterval(toggleSlide, 7000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel-container">
      <img
        src={images[current].link}
        alt={`slide-${current}`}
        className="carousel-image"
      />
      <div className="carousel-overlay">
        <p>{images[current].text}</p>
      </div>
    </div>
  );
};

export default TwoImageCarousel;
